import { Overrides } from "@material-ui/core/styles/overrides"
import { buttonsStatesColors } from "../Button/constants"

export const MuiFab: Overrides["MuiFab"] = {
  root: {
    width: "4.8rem",
    height: "4.8rem",
  },
  extended: {
    height: "4rem",
  },
  primary: buttonsStatesColors.containedPrimary,
  secondary: buttonsStatesColors.containedSecondary,
}
